function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import PropTypes from "prop-types";
import tagComponent from "../../../__internal__/utils/helpers/tags/tags";
import { StyledPreviewPlaceholder } from "./preview-placeholder.style";
const PreviewPlaceholder = ({
  height,
  index,
  lines,
  width,
  ...props
}) => {
  const isLastLine = lines > 1 && lines === index;
  return /*#__PURE__*/React.createElement(StyledPreviewPlaceholder, _extends({
    height: height,
    width: !width && isLastLine ? "80%" : width
  }, tagComponent("preview", props)));
};
export default PreviewPlaceholder;